module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('iframe', {
    staticClass: "fullscreen",
    attrs: {
      "src": _vm.iframeUrl
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a967e2e2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Chat/index.vue
// module id = 685
// module chunks = 0